// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__129ut","gfeWrapper":"CalendarEvent_gfeWrapper__14toW"};